export interface ActionButtonOpts {
	icon?: string;
	text?: string;
	action?: () => void;
}

export enum ButtonColor
{
	GREYSCALE_LIGHT = "greyscale-light",
	GREYSCALE_DARK = "greyscale-dark",
	PRIMARY = "primary",
	SECONDARY = "secondary",
	INFO = "info",
	SUCCESS = "success",
	WARNING = "warning",
	DANGER = "danger",
}

export enum ButtonColorPattern
{
	DEFAULT = "",
	COLORED = "colored",
	DARK_HOVER = "dark-hover",
	TRANSPARENT = "transparent",
	FILL = "fill",
	FILL_LIGHT = "fill-light",
	FILL_DARK = "fill-dark",
	COLORED_TEXT_BORDER = "colored-text-border"
}

export interface BaseButtonOpts {
	label: string;
	color?: ButtonColor;
	pattern?: ButtonColorPattern;
	click: () => void;
}

export enum ButtonSize
{
	DEFAULT = "",
	SMALL = "small",
	SMALL_N_WIDE = "small-n-wide",
	X_SMALL = "x-small",
}

export enum SelectionCardColorPattern
{
	DEFAULT = "",
	FADED = "faded",
}
